import { createFileRoute, redirect } from '@tanstack/react-router';

// `/` is not a page. Campaigns is where an author actually starts (design hand-off §2).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/home' });
  },
});
